import React from 'react';
import styled from 'styled-components';
import Divider from '@mui/material/Divider';

const AboutMe = () => {
  return (
    <AboutMeContainer name='aboutMe'>
      <AboutMeHeader>
        <div>About Me</div>
        <Divider sx={{ width: '90%', justifyContent: 'center' }} />
      </AboutMeHeader>

      <AboutMeContent>
        <AboutMeText>
          <p>
            Hello! I’m Brandy, a licensed Speech-Language Pathologist based in
            Metro Atlanta. I earned my undergraduate degree from New York
            University and my Master’s in Speech-Language Pathology from
            Syracuse University. Originally from New York City, I spent much of
            my career working for the New York City Department of Education,
            supporting children with autism, language and learning difficulties,
            and speech and language delays. Being bilingual in English and
            Chinese allows me to connect with and support families from diverse
            linguistic and cultural backgrounds.
          </p>

          <p>
            With over a decade of experience, I provide speech, language,
            feeding, and AAC (Augmentative and Alternative Communication)
            therapy to children and adults across school, clinic, and telehealth
            settings. My specialty lies in supporting individuals with autism
            and social communication challenges—helping them build functional
            communication skills that foster meaningful connections in everyday
            life. I also work with adults navigating speech, voice, and language
            challenges following neurological events or medical conditions.
            Beyond speech therapy, I’ve also worked as a software engineer—an
            experience that’s taught me how to think creatively, adapt quickly,
            and approach challenges from multiple angles.
          </p>
        </AboutMeText>
        <AboutMeImage src='/diversekids.jpeg' loading='lazy' />
      </AboutMeContent>
    </AboutMeContainer>
  );
};

export default AboutMe;

const AboutMeContainer = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;

  @media (min-width: 375px) and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 10px;
  }
`;

const AboutMeHeader = styled.div`
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;

  div {
    font-size: 35px;
    color: #2c3e50;
    margin-bottom: 1rem;
    font-weight: 400;
    font-family: 'Georgia', serif;
    margin: auto;
    text-align: center;
    padding: 5px;
  }
`;

const AboutMeContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 40px;

  @media (min-width: 375px) and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
    gap: 20px;
  }
`;

const AboutMeText = styled.div`
  max-width: 600px;
  margin: 0;

  p {
    color: #56697dff;
    font-size: 1.1rem;
    line-height: 1.8;
    font-weight: 400;
    text-align: left;
    margin-top: 45px;
    margin-bottom: 1.5rem;

    @media (min-width: 375px) and (max-width: 768px) {
      padding: 15px;
      text-align: center;
      font-size: 14px;
      margin-top: 0;
      margin-bottom: 1rem;
    }
  }
`;

const AboutMeImage = styled.img`
  max-width: 500px;
  width: 100%;
  height: 500px;
  margin-top: 50px;

  @media (max-width: 768px) {
    display: none;
  }
`;
